import React, { useState } from 'react';
import { Box, TextField, Button, Typography, FormControlLabel, Checkbox } from '@mui/material';
import RichTextEditor from './RichTextEditor';
import { GroupInterface } from '../types';

interface GroupFormProps {
  onCreate: (groupData: Partial<GroupInterface>) => void;
}

function GroupForm({ onCreate }: GroupFormProps): React.JSX.Element {
  const [formData, setFormData] = useState({
    name: '',
    order: '',
    details: '',
    active: true
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (formData.name.trim()) {
      onCreate({
        name: formData.name.trim(),
        order: parseInt(formData.order) || 0,
        details: formData.details,
        active: formData.active
      });
      setFormData({ name: '', order: '', details: '', active: true });
    }
  };

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleCheckboxChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.checked
    }));
  };

  const handleEditorChange = (content: string): void => {
    setFormData(prev => ({
      ...prev,
      details: content
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
        <TextField
          label="שם"
          value={formData.name}
          onChange={handleChange('name')}
          size="small"
          required
          sx={{ flex: 1 }}
        />
        <TextField
          label="מיקום במחירון"
          type="number"
          value={formData.order}
          onChange={handleChange('order')}
          size="small"
          sx={{ width: 120 }}
        />
        <FormControlLabel
          control={<Checkbox checked={formData.active} onChange={handleCheckboxChange('active')} color="primary" />}
          label="פעיל"
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography>פרטים</Typography>
        <RichTextEditor
          content={formData.details}
          onChange={handleEditorChange}
          placeholder="הזן פרטי קבוצה..."
        />
      </Box>
      <Button type="submit" variant="contained" color="primary">
        צור
      </Button>
    </form>
  );
}

export default GroupForm; 